import axios from '@/api/axios';
import qs from 'qs';
import * as s_Interface from '@/interface/store/request';
import * as c_Interface from '@/interface/components/request';
import { FilePayload, InsertDataPayload } from '@/interface/components';

export const getRequests = (
  groupId: string,
  attributes: string,
  include: string,
  offset: number,
  limit: number,
  order: string,
  status: { status: Array<string> },
  filters: s_Interface.RequestFilter,
  query: string,
  hasDropdown: boolean
) => {
  const filterObject = {};
  for (let key in filters) {
    if (filters[key].subArray.length > 0) {
      switch (key) {
        case 'Types':
          Object.assign(filterObject, { fkTypeId: filters[key].subArray });
          break;
        case 'Vendors':
          Object.assign(filterObject, { fkVendorId: filters[key].subArray });
          break;
        case 'Manufacturers':
          Object.assign(filterObject, { fkManufacturerId: filters[key].subArray });
          break;
        case 'Users':
          Object.assign(filterObject, { requestedBy: filters[key].subArray });
          break;
        case 'Grants':
          Object.assign(filterObject, { fkGrantId: filters[key].subArray });
          break;
      }
    }
  }
  if (Object.keys(filterObject).length > 0) {
    Object.assign(filterObject, status);
    const where = encodeURIComponent(qs.stringify(filterObject));
    return axios.get(
      `groups/${groupId}/requests?limit=${limit}&offset=${offset}&order=${order}&where=${where}&query=${query}&hasDropdown=${hasDropdown}`
    );
  }
  const encodedStatus = encodeURIComponent(qs.stringify(status));
  return axios.get(
    `groups/${groupId}/requests?limit=${limit}&offset=${offset}&order=${order}&where=${encodedStatus}&query=${query}&hasDropdown=${hasDropdown}`
  );
};
export const setRequest = (groupId: string, payload: c_Interface.RequestItemPayload) =>
  axios.post(`groups/${groupId}/requests`, payload);
export const setRequestBulk = (groupId: string, payload: c_Interface.RequestBulkPayload[]) =>
  axios.post(`groups/${groupId}/requests/bulk`, payload);
export const requestStatusChange = (groupId: string, payload: s_Interface.RequestItem) =>
  axios.put(`groups/${groupId}/requests/status`, payload);
export const deleteRequests = (groupId: string, payload: Array<string>) =>
  axios.delete(`groups/${groupId}/requests/bulk`, { data: payload });

export const updateRequestStatus = (groupId: string, requestId: string, payload: any) =>
  axios.put(`groups/${groupId}/requests/${requestId}`, payload);
export const setAttachment = (
  groupId: string,
  requestId: string,
  files: Array<InsertDataPayload>
) => axios.post(`groups/${groupId}/requests/${requestId}/attachments`, files);
export const getAttachments = (groupId: string, requestId: string) =>
  axios.get(`groups/${groupId}/requests/${requestId}/attachments`);
export const deleteAttachment = (groupId: string, requestId: string, attachmentId: string) =>
  axios.delete(`groups/${groupId}/requests/${requestId}/attachments/${attachmentId}`);
export const attachmentsRequestSignUrl = (
  groupId: string,
  requestId: string,
  payload: Array<FilePayload>
) => axios.post(`groups/${groupId}/requests/${requestId}/attachments/sign`, payload);
export const attachmentsRequestUpload = (url: string, file: File) =>
  axios.put(url, file, { headers: { 'Content-Type': file.type } });
export const getRequest = (groupId: string, requestId: string) =>
  axios.get(`/groups/${groupId}/requests/${requestId}`);
export const updateRequest = (groupId: string, requestId: string, payload: { status: string }) =>
  axios.put(`groups/${groupId}/requests/${requestId}`, payload);
export const bulkUpdateRequest = (
  groupId: string,
  payload: { id: string; fkPurchaseOrderId: string }[]
) => axios.put(`groups/${groupId}/requests/bulk`, payload);
export const getPurchaseOrders = (groupId: string) =>
  axios.get(`groups/${groupId}/purchase-orders`);
export const setPurchaseOrder = (groupId: string, poName: { name: string }) =>
  axios.post(`groups/${groupId}/purchase-orders`, poName);
export const exportRequest = (groupId: string, startAt?: string, endAt?: string) => {
  if (startAt && endAt) {
    return axios.get(`groups/${groupId}/requests/exports?startAt=${startAt}&endAt=${endAt}`);
  } else {
    return axios.get(`groups/${groupId}/requests/exports`);
  }
};
export const getTemplateRequest = (groupId: string) =>
  axios.get(`groups/${groupId}/requests/template`);
export const signUrlRequestImport = (groupId: string, payload: FilePayload) =>
  axios.post(`groups/${groupId}/requests/imports/sign`, payload);
export const requestImport = (url: string, file: any) =>
  axios.put(url, file, { headers: { 'Content-Type': file.type } });
export const requestUpload = (groupId: string, payload: FilePayload) =>
  axios.post(`groups/${groupId}/requests/imports`, payload);
export const poSignURI = (groupId: string, purchaseOrderId: string, payload: Array<FilePayload>) =>
  axios.post(`groups/${groupId}/purchase-orders/${purchaseOrderId}/attachments/sign`, payload);
export const setS3PoAttachment = (url: string, file: any) =>
  axios.put(url, file, { headers: { 'Content-Type': file.type } });
export const setPoAttachment = (
  groupId: string,
  purchaseOrderId: string,
  payload: Array<InsertDataPayload>
) => axios.post(`groups/${groupId}/purchase-orders/${purchaseOrderId}/attachments`, payload);
export const setComment = (groupId: string, requestId: string, payload: { body: string }) =>
  axios.post(`groups/${groupId}/requests/${requestId}/comments`, payload);
export const getComments = (groupId: string, requestId: string) =>
  axios.get(`groups/${groupId}/requests/${requestId}/comments`);
export const deleteComment = (groupId: string, requestId: string, commentId: string) =>
  axios.delete(`groups/${groupId}/requests/${requestId}/comments/${commentId}`);
export const updateComment = (
  groupId: string,
  requestId: string,
  commentId: string,
  payload: { body: string }
) => axios.put(`groups/${groupId}/requests/${requestId}/comments/${commentId}`, payload);
export const getRequestHistories = (groupId: string, requestId: string) =>
  axios.get(`groups/${groupId}/requests/${requestId}/histories`);

export const getQueryParams = (groupId: string) =>
  axios.get(`groups/${groupId}/query-params?type=request`);
export const updateQueryParams = (groupId: string, payload: any) =>
  axios.put(`groups/${groupId}/query-params?type=request`, payload);
